/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    ADD_LOANS(state, item) {
        state.employeeFiledLoans.unshift(item)
    },
    UPDATE_LOANS(state, item) {
        const index = state.employeeFiledLoans.findIndex((e) => e.employeeFiledLoansId === item.employeeFiledLoansId)
        Object.assign(state.employeeFiledLoans[index], item)
    },
    GET_ALL_LOANS(state, payload) {
        state.employeeFiledLoans = payload
        //console.log('GET ALL LOANS')    
        //console.log(state.employeeFiledLoans)
    },
   
    UPLOAD_PHOTO(state, photo){
        state.photoUpload.unshift(photo)
    },
    GET_ALL_APPROVERS(state, approvers){
        state.approvers = approvers
        //console.log(state.approvers)
    },
    UNSUBMIT_LOANS(state, loanId){
        //console.log('okay')
        //console.log(loanId)
        const index = state.employeeFiledLoans.findIndex((e) => e.employeeFiledLoansId === loanId)
        Object.assign(state.employeeFiledLoans[index], {
            isDraft: true, 
            isSubmitted: false})
        
        
    },
    CANCELLED_LOANS(state, items){
        const index = state.employeeFiledLoans.findIndex((e) => e.employeeFiledLoansId === items.employeeFiledLoansId)
        Object.assign(state.employeeFiledLoans[index], { 
            isDraft: items.isDraft, 
            isSubmitted: items.isSubmitted, 
            isCancelled: items.isCancelled, 
            remarks: items.remarks, 
            isReviewerRevised: items.isReviewerRevised, 
            isApproverRevised: items.isApproverRevised })
    },
    RETRACKED_LOANS(state, items){
        const index = state.employeeFiledLoans.findIndex((e) => e.employeeFiledLoansId === items.employeeFiledLoansId)
        Object.assign(state.employeeFiledLoans[index], {
            isDraft: items.isDraft, 
            isRetracted: items.isRetracted,
            retractedOn: items.retractedOn,
            isReviewerApproved: items.isReviewerApproved,
            isApproverApproved: items.isApproverApproved,
            remarks: items.remarks})

    },
    REVIEWED_LOANS(state, items){
        const index = state.employeeFiledLoans.findIndex((e) => e.employeeFiledLoansId === items.employeeFiledLoansId)
        Object.assign(state.employeeFiledLoans[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerApproved: items.isReviewerApproved, 
            reviewerApprovedOn : items.reviewerApprovedOn, 
            isRetracted : items.isRetracted
        })

       
    },
    REVIEWERDENIED_LOANS(state, items){
        const index = state.employeeFiledLoans.findIndex((e) => e.employeeFiledLoansId === items.employeeFiledLoansId)
        Object.assign(state.employeeFiledLoans[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerDenied: items.isReviewerDenied, 
            reviewerDeniedOn : items.reviewerDeniedOn, 
            isRetracted : items.isRetracted, 
            reviewerComments: items.reviewerComments,
        })
    },
    REVIEWERREVISED_LOANS(state, items){
        const index = state.employeeFiledLoans.findIndex((e) => e.employeeFiledLoansId === items.employeeFiledLoansId)
        Object.assign(state.employeeFiledLoans[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerRevised: items.isReviewerRevised, 
             reviewerForRevisionOn : items.reviewerForRevisionOn, 
            isRetracted : items.isRetracted, 
            reviewerComments: items.reviewerComments,
        })
    },
    APPROVED_LOANS(state, items){
        const index = state.employeeFiledLoans.findIndex((e) => e.employeeFiledLoansId === items.employeeFiledLoansId)
        Object.assign(state.employeeFiledLoans[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerApproved: items.isReviewerApproved, 
            reviewerApprovedOn : items.reviewerApprovedOn, 
            isRetracted : items.isRetracted
        })

       
    },
    APPROVERDENIED_LOANS(state, items){
        const index = state.employeeFiledLoans.findIndex((e) => e.employeeFiledLoansId === items.employeeFiledLoansId)
        Object.assign(state.employeeFiledLoans[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerDenied: items.isReviewerDenied, 
            reviewerDeniedOn : items.reviewerDeniedOn, 
            isRetracted : items.isRetracted, 
            reviewerComments: items.reviewerComments,
        })
    },
    APPROVERREVISED_LOANS(state, items){
        const index = state.employeeFiledLoans.findIndex((e) => e.employeeFiledLoansId === items.employeeFiledLoansId)
        Object.assign(state.employeeFiledLoans[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerRevised: items.isReviewerRevised, 
             reviewerForRevisionOn : items.reviewerForRevisionOn, 
            isRetracted : items.isRetracted, 
            reviewerComments: items.reviewerComments,
        })
    },
}